<template>
	<div>
		<Dialog
			title="Import output"
			:show="show"
			max-width="900"
			@close="close"
		>
			<template slot="content" v-if="projectsWithOutputs.length > 0">
				<v-treeview
					:active.sync="selectedIds"
					:items="projectsWithOutputs"
					item-children="outputs"
					activatable
					open-all
					open-on-click
					hoverable
				>
					<template slot="label" slot-scope="{ item }">
						{{ item.name }}
						<span v-if="item.shared" class="caption">(shared)</span>
							
						<span v-if="item.duplicatesCount > 1" class="error--text caption">
							({{ item.duplicatesCount }} outputs with same name)
						</span>
					</template>
					<template slot="append" slot-scope="{ active, leaf }">
						<template v-if="leaf">
							<span v-if="active" class="success--text ma-2">SELECTED</span>
							<span v-else class="select-text success--text ma-2">SELECT</span>
						</template>
					</template>
				</v-treeview>
			</template>
			<template slot="buttons">
				<v-btn
					color="success"
					flat
					:disabled="!selected"
					@click="importOutputs"
				>
					Import
				</v-btn>
			</template>
		</Dialog>
		<Confirm ref="confirm">
			<v-card-text
				v-if="selected"
				slot="text"
			>
				<p>Selected output "{{selectedOutput.name}}" to be imported.</p>
				<p v-if="!validSelection" class="error--text">Unable to import. You have two or more outputs in this project with the same name as selected output. Try to rename them, so they have unique names (except for shared outputs).</p>
				<p v-else-if="hasDuplicate">Current project has an output with the same name as selected output. Do you want to replace it or keep them both (create a copy)?</p>
				<p v-else>Are you sure you want to import selected output to this project?</p>
			</v-card-text>
			<template
				slot="buttons"
				slot-scope="props"
			>
				<template v-if="!validSelection">
					<span />
				</template>
				<template v-else-if="hasDuplicate">
					<v-btn
						color="success"
						flat
						@click="props.callback('replace')"
					>
						Replace
					</v-btn>
					<v-btn
						color="success"
						flat
						@click="props.callback('copy')"
					>
						Keep Both
					</v-btn>
				</template>
				<template v-else>
					<v-btn
						color="success"
						flat
						@click="props.callback(true)"
					>
						Ok
					</v-btn>
				</template>
			</template>
		</Confirm>
	</div>
</template>

<script>
import Dialog from '@/components/Global/Dialog';
import Confirm from '@/components/Confirm';
import { Output } from '@/models/Output';
import axios from '@/util/axios';

export default {
	components: {
		Dialog,
		Confirm
	},
	data() {
		return {
			show: false,
			selectedIds: [],
		};
	},
	created() {
		const output = new Output();
		
		
		// console.log(this.projectsWithOutputs);
		
	},
	watch: {
		projectsWithOutputs: {
			handler(val) {
				console.log(val);
			},
			deep: true,
		},
	},
	computed: {
		project() {
			return this.$store.get('projects/currentProject');
		},
		projectOutputNames() {
			return this.project.outputs.map(output => output.name);
		},
		projectsWithOutputs() {
			return this.$store.get('outputs/allByProjects');
		},
		selected() {
			return this.selectedIds[0] || null;
		},
		selectedOutput() {
			return this.allOutputs.find(output => output.id === this.selected);
		},
		allOutputs() {
			let allOutputs = [];
			this.projectsWithOutputs.forEach(project => {
				allOutputs.push(...project.outputs);
			});
			return allOutputs;
		},
		validSelection() {
			return (this.selected && this.selectedOutput.duplicatesCount < 2);
		},
		hasDuplicate() {
			return this.selectedOutput.duplicatesCount === 1;
		},
	},
	methods: {
		importOutputs() {
			this.$refs.confirm.createConfirm('Import selected outputs', 'success').then((answer) => {
				if (!answer) {
					return;
				}
				
				this.$emit('importing', true);
				
				const data = {
					copy: answer === 'copy', // true if answer is 'copy', false if answer is 'replace', or any other
					projectId: this.project.id,
					outputId: this.selected,
				}
				
				axios.post('/outputs/import', data).then((resp) => {
					const output = new Output(resp.data);
					const index = this.project.outputs.findIndex(o => o.id === output.id);
					
					// If override, replace in collection
					if (index > -1) {
						this.project.outputs.splice(index, 1, output);
						return;
					}
					// Else add to collection
					/** @todo not reactive, fix */
					this.project.outputs.push(output);
					// Update projectsWithOutputs with new potential duplicate
					this.$store.dispatch('outputs/updateAllOutputsByProject', output.name);
				}).catch((e) => {
					dump('Error importing outputs', e);
					this.$notify('error', `Failed to import output.`);
				}).finally(() => {
					this.$emit('importing', false);
				});
				this.close();
			});
		},
		close() {
			this.show = false;
			this.selectedIds = [];
		},
	}
};
</script>

<style lang="scss">
span.select-text {
	display: none;
}
.v-treeview-node__root {
	border: 1px solid transparent;
}
.v-treeview-node:not(.v-treeview-node--leaf) {
	> .v-treeview-node__root:hover {
		background-color: transparent !important;
	}
}
.v-treeview-node__root:hover {
	background-color: transparent !important;
	span.select-text {
		display: inline;
	}
}
.v-treeview-node--active,
.v-treeview-node--leaf > .v-treeview-node__root:hover {
	background-color: transparent !important;
	border: 1px solid #4caf50;
	border-radius: 3px;
}
</style>
